import { ReactNode } from "react";

/* Prop Types */
interface DropdownItemProps extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  onClick?: () => void;
  dropdownRef?: React.RefObject<HTMLUListElement>;
  stayOpen?: boolean;
  href?: string;
  disabled?: boolean;
}

/*
 * Custom Dropdown Item Component
 * This component is used to create custom dropdown items inside the custom dropdown component
 */
export const CustomDropdownItem = ({ children, onClick = () => {}, className, dropdownRef, stayOpen = false, href, disabled = false }: DropdownItemProps) => {
  /* Handlers */
  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    if (disabled) return;
    onClick?.();
    if (dropdownRef && dropdownRef.current && !stayOpen) {
      dropdownRef.current.blur();
    }
  };

  return (
    <li onClick={handleClick} className="w-full">
      <a
        href={href}
        aria-disabled={disabled}
        tabIndex={disabled ? -1 : undefined}
        className={`${disabled ? "opacity-50 cursor-not-allowed pointer-events-none" : ""} ${className || ""}`.trim()}
        onClick={(e) => {
          if (disabled) {
            e.preventDefault();
            return;
          }
          if (href) {
            return;
          }
          e.preventDefault();
        }}
      >
        {children}
      </a>
    </li>
  );
};
